import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ViewChildren,
  QueryList,
  SimpleChanges,
  OnChanges
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import _ from 'lodash';
import { SelectItem, LazyLoadEvent } from 'primeng/api';
import { MultiSelect } from 'primeng/multiselect';
import { Table } from 'primeng/table';
import { Subscription } from 'rxjs';
import {
  EventSearchType,
  ProgramTypesGUID,
  EventStatus,
  EventStatusNames,
  ProgramTypes
} from '../../../models/_enum-collections';
import { MrppPreviewInput } from '../../../models/event-preview-input.model';
import { EventRegistrationModel } from '../../../models/event-registration.model';
import { EventSearchFilterRequest } from '../../../models/event-search-filter-request.model';
import { AppConstants } from '../../common/app-constants';
import { EditEventComponent } from '../../mcap-events/components/edit-event/edit-event.component';
import { LocalStorageService } from '../../services/local-storage-service';
import { OsmosisEditService } from '../../services/osmosis-edit.service';
import { CommonSharedModule } from '../../common/shared.module';
import { MrppPreviewComponent } from '../mrpp-preview/mrpp-preview.component';
import { EventDashboardService } from '../../services/event-dashboard.service';

@Component({
  selector: 'app-mrpp-customer-ack-table',
  templateUrl: './mrpp-customer-ack-table.component.html',
  styleUrls: ['./mrpp-customer-ack-table.component.scss'],
  standalone: true,
  imports: [CommonSharedModule, EditEventComponent, MrppPreviewComponent]
})
export class MrppCustomerAckTableComponent implements OnInit, OnChanges {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private localStorage: LocalStorageService,
    private eventDashboardService: EventDashboardService,
    private osmService: OsmosisEditService
  ) {}

  excelLoading = false;
  @Input() loading!: boolean;
  scrollableCols = new Array<any>();
  loadingIcon = 'fa-circle-o-notch';
  dataViewRecsPerPage!: number;
  pageLinksPerPage!: number;
  tblPageNumber = 1;
  totalRecords!: number;
  loadEditComponent!: boolean;
  editNav = false;
  eventIdPassToChild!: number;
  display!: boolean;
  showFullScreen!: boolean;
  canShowMrppPreviewModel!: boolean;
  @Input() eventSearchType!: EventSearchType;
  eventEditInput!: EventRegistrationModel;
  eventsDisplayed!: EventRegistrationModel[];
  allEventsDisplayed!: EventRegistrationModel[];
  eventSearchSubscription!: Subscription;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  delayedLoadSearchContent!: Function;
  eventSearchFilterRequest!: EventSearchFilterRequest;
  eventStatusDropdownItems: SelectItem[] = [];
  l1InternalStatusDropdownItems: SelectItem[] = [];
  l2InternalStatusDropdownItems: SelectItem[] = [];
  @ViewChild('dt', { static: false }) dt!: Table;
  @ViewChild('editNavChild', { static: false })
  editNavChild!: EditEventComponent;

  @ViewChildren('tak') components!: QueryList<MultiSelect>;
  mrppPreviewInput!: MrppPreviewInput;
  mrppProgram: string = ProgramTypesGUID.MRPP;

  ngOnInit() {
    this.loadEventStatusDropdownItems();
    this.getL1InternalStatusList();
    this.getL2InternalStatusList();
    this.delayedLoadSearchContent = _.debounce(this.loadEvents, 1000);

    this.dataViewRecsPerPage = AppConstants.dataListRecsPerPage;
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;

    this.eventSearchFilterRequest = {
      pageSize: this.dataViewRecsPerPage,
      page: this.tblPageNumber
    };

    this.loadEvents({ first: 0 });

    this.scrollableCols = [
      { field: 'eventKey', header: 'Event Id' },
      { field: 'eventName', header: 'Workshop Type' },
      { field: 'partnerOrgName', header: 'Partner Org' },
      { field: 'fiscalYear', header: 'Fiscal Year' },
      { field: 'partnerMpnid', header: 'Partner MPN ID' },
      { field: 'l1InternalStatus', header: 'L1 Internal Status' },
      { field: 'l2InternalStatus', header: 'L2 Internal Status' },
      { field: 'poeDocUploadDate', header: 'Uploaded Date' },
      { field: 'submittedDate', header: 'Submitted Date' },
      { field: 'customerOrgName', header: 'Customer Org' },
      { field: 'customerCountry', header: 'Customer Country' }
    ];
    this.localStorage.setFullscreenMode(true);
    this.showFullScreen = this.localStorage.getFullscreenMode();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['eventSearchType'] && !changes['eventSearchType'].firstChange) {
      this.loadEvents({} as LazyLoadEvent);
    }
  }

  loadEventStatusDropdownItems(): void {
    const statusKeys = Object.keys(EventStatus).filter(
      x => !isNaN(parseInt(x, 0))
    );

    for (const key of statusKeys) {
      const itm: SelectItem = {
        label: EventStatusNames[EventStatus[parseInt(key, 0)]],
        value: EventStatusNames[EventStatus[parseInt(key, 0)]]
      };
      this.eventStatusDropdownItems.push(itm);
    }
  }

  getL1InternalStatusList() {
    this.osmService.getL1InternalStatusDropDown().subscribe(PTList => {
      for (const item of PTList) {
        const fl1InternalStatusDrpdwn: SelectItem = {
          label: item.l1internalStatus,
          value: item.l1internalStatus
        };
        this.l1InternalStatusDropdownItems.push(fl1InternalStatusDrpdwn);
      }
    });
  }

  getL2InternalStatusList() {
    this.osmService.getL2InternalStatusDropDown().subscribe(PTList => {
      for (const item of PTList) {
        const fl1InternalStatusDrpdwn: SelectItem = {
          label: item.l2internalStatus,
          value: item.l2internalStatus
        };
        this.l2InternalStatusDropdownItems.push(fl1InternalStatusDrpdwn);
      }
    });
  }

  loadEvents(event: LazyLoadEvent, refreshAfterPreview = false): void {
    if (!refreshAfterPreview) {
      if (event) {
        this.pageChange(event);
      } else {
        this.pageChange({ first: 0 });
      }
    }

    this.loading = true;
    if (this.eventSearchSubscription) {
      this.eventSearchSubscription.unsubscribe();
    }
    this.eventSearchFilterRequest.eventDocumentTypeId = this.eventSearchType;
    this.eventSearchFilterRequest.programTypeId = ProgramTypes.MRPP;
    this.eventSearchSubscription = this.eventDashboardService
      .getEngagementsForMrppCustAckList(this.eventSearchFilterRequest)
      .subscribe(data => {
        this.eventsDisplayed = data.results;
        this.totalRecords = data.rowCount;
        this.loading = false;
      });
  }

  export() {
    this.router.navigate(['download-csv'], { relativeTo: this.route });
  }

  pageChange(e) {
    const calc = e.first / this.dataViewRecsPerPage + 1;

    this.tblPageNumber = calc;
    this.eventSearchFilterRequest.page = this.tblPageNumber;
  }

  onSearchInput(event, dt) {
    if (!event.target.value || event.target.value.trim() !== '') {
      dt.filterGlobal(event.target.value, 'contains');
    }
  }

  applyFilter(event) {
    this.totalRecords = event.filteredValue.length;
    this.pageChange({ first: 0 });
  }

  searchOrFilterEngagements() {
    this.eventSearchFilterRequest.page = 1;
    if (this.dt) {
      this.dt.first = this.eventSearchFilterRequest.page;
    }

    if (
      this.eventSearchFilterRequest.eventKey != undefined &&
      this.eventSearchFilterRequest.eventKey.toString() === ''
    ) {
      this.eventSearchFilterRequest.eventKey = undefined;
    }

    if (
      this.eventSearchFilterRequest.partnerOrgName != undefined &&
      this.eventSearchFilterRequest.partnerOrgName.toString() === ''
    ) {
      this.eventSearchFilterRequest.partnerOrgName = undefined;
    }

    if (
      this.eventSearchFilterRequest.partnerMpnid != undefined &&
      this.eventSearchFilterRequest.partnerMpnid.toString() === ''
    ) {
      this.eventSearchFilterRequest.partnerMpnid = undefined;
    }

    if (
      this.eventSearchFilterRequest.fiscalYear != undefined &&
      this.eventSearchFilterRequest.fiscalYear.toString() === ''
    ) {
      this.eventSearchFilterRequest.fiscalYear = undefined;
    }

    this.delayedLoadSearchContent();
  }

  get currentPageInfo() {
    if (this.totalRecords === 0) {
      return 'No Record Found';
    } else if (this.totalRecords > 0 && this.tblPageNumber === 1) {
      return `Showing 1 - ${this.eventsDisplayed.length} of ${this.totalRecords} Records`;
    } else if (this.totalRecords > 0 && this.tblPageNumber > 1) {
      const rangeStart =
        (this.tblPageNumber - 1) * this.dataViewRecsPerPage + 1;
      let rangeEnd = 0;

      if (this.tblPageNumber * this.dataViewRecsPerPage >= this.totalRecords) {
        rangeEnd = this.totalRecords;
      } else if (
        this.tblPageNumber * this.dataViewRecsPerPage <
        this.totalRecords
      ) {
        rangeEnd = this.tblPageNumber * this.dataViewRecsPerPage;
      }

      return `Showing ${rangeStart} - ${rangeEnd} of ${this.totalRecords} Records`;
    }
    return '';
  }

  reset() {
    this.components['_results'].forEach(ds => {
      ds.value = null;
    });

    if (this.dt) {
      this.dt.filter('', 'taskOwner', 'in');
      this.dt.filter('', 'l1InternalStatus', 'in');
      this.dt.filter('', 'l2InternalStatus', 'in');
      this.dt.filter('', 'engagementType', 'in');
      this.dt.reset();
    }

    this.eventSearchFilterRequest = {
      pageSize: this.dataViewRecsPerPage,
      page: this.tblPageNumber
    };

    this.display = false;
  }

  editRequestDetails(id: number) {
    this.loadEditComponent = true;
    this.editNav = true;
    this.eventIdPassToChild = id;
    this.eventEditInput = this.eventsDisplayed.filter(
      x => x.eventRegistrationId === id
    )[0];
  }

  previewFile(eventRegistrationId) {
    this.loading = false;
    this.mrppPreviewInput = {
      previewFileIndex: 0,
      eventId: eventRegistrationId,
      eventIdList: this.eventsDisplayed.map(event => event.eventRegistrationId),
      eventCustomers: this.eventsDisplayed.map(item => ({
        eventId: item.eventRegistrationId,
        eventCustomers: item.eventCustomers || []
      })),
      isCustomerAckApproval: true
    } as MrppPreviewInput;

    this.canShowMrppPreviewModel = true;
  }

  closePreview() {
    this.canShowMrppPreviewModel = false;
  }

  onShowFullScreenChanged(showFullscreenValue: boolean) {
    this.showFullScreen = showFullscreenValue;
    this.localStorage.setFullscreenMode(this.showFullScreen);
  }

  refresh() {
    this.loadEvents({} as LazyLoadEvent, true);
  }

  sort(columnKey: string) {
    const column = this.scrollableCols.find(x => x.field === columnKey);

    column.descending =
      column.descending === undefined ? true : !column.descending;

    const columnIndex = this.scrollableCols.indexOf(column);

    this.scrollableCols[columnIndex] = column;

    this.eventSearchFilterRequest.sortField = column.field;
    this.eventSearchFilterRequest.sortOrderDescending = column.descending;
    this.loadEvents({} as LazyLoadEvent);
  }

  onCloseEditModal() {
    this.loadEditComponent = false;
    this.editNav = false;
    this.refresh();
    this.setEventStatus();
  }

  async setEventStatus() {
    const event = await this.loadEventInfo();
    if (event) {
      const eventIndex = this.eventsDisplayed.indexOf(
        this.eventsDisplayed.find(
          (event): event is EventRegistrationModel =>
            event.eventRegistrationId ===
            this.eventEditInput.eventRegistrationId
        ) || ({} as EventRegistrationModel)
      );
      this.eventsDisplayed[eventIndex] = event;
    }
  }

  async loadEventInfo() {
    return await this.eventDashboardService
      .getEventRegistration(this.eventEditInput.eventRegistrationId)
      .toPromise();
  }

  getUploadedDate(rawData: EventRegistrationModel): Date {
    if (rawData.engagementCustomerAcknowledgement != null) {
      return rawData.engagementCustomerAcknowledgement[0].formattedUploadDate;
    }
    return new Date();
  }

  getCustomerName(rawData: EventRegistrationModel): string {
    if (rawData.eventCustomers != null) {
      return rawData.eventCustomers[0].customerName;
    }
    return '';
  }

  getCustomerCountry(rawData: EventRegistrationModel): string {
    if (rawData.eventCustomers != null) {
      return rawData.eventCustomers[0].customerCountry;
    }
    return '';
  }
}
